export const BasePaths = {
  MAIN: "/app",
  USER: "/user",
  SUPPLIERS: "/app/suppliers",
  LEAVE: "/app/leave",
  PERFORMANCE: "/app/performance-management",
  ASSET: "/app/asset",
};
export const PublicPaths = {
  HOME: "/",
  LOGIN: "/",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password/:id",
  REGISTER: "/create-account",
};

export const PrivatePaths = {
  DASHBOARD: "/app/dashboard",
  INVESTMENT: "/app/investment",
  COURSES: "/app/investment/training-courses",
  ASSESSMENT: "/app/assessment",
  ASSESSMENTTEST: "/app/assessment/start",
  INVESTOR: "/app/investment/investor-companies",
  ACTIVE: "/app/investment/active-investments",
  HISTORY: "#/app/history",
  SERVICES: "#/app/services",
  ADVISORY: "#/app/services/investment-advisory",
  WEALTH: "#/app/services/wealth-management",
  TRADING: "#/app/services/trading",
  ALTERNATIVE: "#/app/services/alternative-investments",
  CORPORATE: "#/app/services/corporate-advisory",
  DIGITAL: "#/app/services/digital",
  ACCOUNT: "/app/account",
};

export const AdminPrivatePaths = {
  DASHBOARD: "/app/dashboard",
  CATEGORY: "/app/config/onboarding/category",
  COLOR: "/app/config/color",
  ONBOARDING: "/app/config/onboarding",
  ADMIN: "/app/config/admin",
  TRAINING: "/app/training",
  ASSESSMENT: "/app/config/assessment",
  QST: "/app/config/onboarding",
  GROWTH: "/app/growth",
};
